import { logError } from '@savgroup-front-common/configuration/appInsights/AppInsights';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { AuthConfiguration } from '@/configuration';

const getOwnerSummaryQuery = async () => {
  const ENDPOINT = `${AuthConfiguration.authority}/account/me`;

  try {
    const response = await fetch(ENDPOINT, {
      method: SUPPORTED_METHODS.GET,
      credentials: 'include',
    });

    return response;
  } catch (exception) {
    logError(`An error is occured to get the owner Summary ${exception}`);

    return undefined;
  }
};

export default getOwnerSummaryQuery;
